import { render, staticRenderFns } from "./SectionApp.vue?vue&type=template&id=33f22906&scoped=true&"
import script from "./SectionApp.vue?vue&type=script&lang=js&"
export * from "./SectionApp.vue?vue&type=script&lang=js&"
import style0 from "./SectionApp.vue?vue&type=style&index=0&id=33f22906&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f22906",
  null
  
)

export default component.exports